import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="mt-20 border-t border-stone-200 py-8 dark:border-stone-800">
      <div className="flex flex-col gap-4 text-sm text-stone-500 dark:text-stone-400 sm:flex-row sm:items-center sm:justify-between">
        <nav className="flex flex-wrap items-center gap-5">
          <Link
            className="transition hover:text-stone-900 dark:hover:text-stone-100"
            to="/about"
          >
            About
          </Link>
          <Link
            className="transition hover:text-stone-900 dark:hover:text-stone-100"
            to="/projects"
          >
            Projects
          </Link>
          <a
            className="transition hover:text-stone-900 dark:hover:text-stone-100"
            href="mailto:kingobiorah@gmail.com"
          >
            Contact
          </a>
        </nav>
        <p>Copyright {currentYear} Obinna Okwuolisa. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
